import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../../api/axios';
import {
  AdminFilterSelect,
  AdminPageHeader,
  AdminStatusBadge,
  AdminTableCard,
  useAdminList,
} from './AdminUi';
import './admin.css';

const FILTER_OPTIONS = [
  { value: '', label: 'All statuses' },
  ...['PENDING', 'SUCCEEDED', 'FAILED', 'REFUNDED', 'CANCELED'].map((s) => ({
    value: s,
    label: s,
  })),
];

export default function AdminPayments() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState(searchParams.get('status') || '');
  const { data, loading, error } = useAdminList(
    () => api.get('admin/payments/', { params: { status: status || undefined, limit: 100 } }),
    [status]
  );

  return (
    <div>
      <AdminPageHeader title="Payments" subtitle={`${data.total} payment records`}>
        <AdminFilterSelect
          className="admin-filter-dd--end"
          value={status}
          onChange={setStatus}
          options={FILTER_OPTIONS}
          placeholder="All statuses"
          aria-label="Filter by status"
        />
      </AdminPageHeader>

      {error && <div className="alert alert-danger">{error}</div>}
      {loading ? (
        <div className="text-center py-5"><div className="spinner-border text-primary" /></div>
      ) : data.results.length === 0 ? (
        <div className="admin-card p-4 text-center text-muted">No payments</div>
      ) : (
        <>
          <div className="admin-mobile-list d-lg-none">
            {data.results.map((p) => (
              <article key={p.id} className="admin-mobile-card">
                <div className="admin-mobile-card-top">
                  <div className="min-w-0">
                    <div className="admin-mobile-card-id">#{p.id}</div>
                    <div className="admin-mobile-card-title">
                      ${Number(p.total_amount).toFixed(2)}
                    </div>
                    <div className="admin-mobile-card-sub text-truncate">
                      {p.user_email || '—'}
                    </div>
                  </div>
                  <AdminStatusBadge status={p.status} />
                </div>
                <div className="admin-mobile-card-meta">
                  <div>
                    <span className="label">Doctor</span>
                    <span className="value">{p.doctor_name || '—'}</span>
                  </div>
                  <div>
                    <span className="label">Stripe PI</span>
                    <span className="value" style={{ wordBreak: 'break-all' }}>
                      {p.stripe_payment_intent_id || '—'}
                    </span>
                  </div>
                  <div>
                    <span className="label">Date</span>
                    <span className="value">
                      {p.created_at ? new Date(p.created_at).toLocaleString() : '—'}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="d-none d-lg-block">
            <AdminTableCard>
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>User</th>
                    <th>Doctor</th>
                    <th>Stripe PI</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {data.results.map((p) => (
                    <tr key={p.id}>
                      <td>{p.id}</td>
                      <td className="fw-bold">${Number(p.total_amount).toFixed(2)}</td>
                      <td><AdminStatusBadge status={p.status} /></td>
                      <td className="small">{p.user_email || '—'}</td>
                      <td>{p.doctor_name || '—'}</td>
                      <td className="small text-muted text-truncate" style={{ maxWidth: 140 }}>
                        {p.stripe_payment_intent_id || '—'}
                      </td>
                      <td className="small">
                        {p.created_at ? new Date(p.created_at).toLocaleString() : '—'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </AdminTableCard>
          </div>
        </>
      )}
    </div>
  );
}
